import { createRecordingGateway, type RecordingOptions } from '@/utils/recording-gateway';

import {
  type EnrichmentStats,
  enrichmentStatsSchema,
  type StatsRange,
} from '../../_shared/domain/stats.domain';
import type { MetricsGateway } from './metrics.gateway';

interface InMemoryOptions extends RecordingOptions<MetricsGateway> {
  stats?: EnrichmentStats;
  /** Answers per range: lets a test return different figures for each period. */
  statsFor?: (range: StatsRange | undefined) => EnrichmentStats;
}

const EMPTY_STATS: EnrichmentStats = enrichmentStatsSchema.parse({});

/**
 * Deterministic in-memory gateway for tests. Records every fetchStats call with
 * its range (`calls[i].args[0]`) and lets a test force a failure or hang, so the
 * saga's success / error branches run without a network.
 */
export function createInMemoryGateway(options: InMemoryOptions = {}) {
  return createRecordingGateway<MetricsGateway>(
    {
      fetchStats: (range) => options.statsFor?.(range) ?? options.stats ?? EMPTY_STATS,
    },
    options,
  );
}
